import { useSearchParams } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { PageHeader } from "@/components/core/AppLayout";
import { CaseList } from "@/components/site/CaseList";
import { RequestsInbox } from "@/components/site/RequestsInbox";
import { SiteTexts } from "@/components/site/SiteTexts";

const TABS = [["case", "Case history"], ["richieste", "Richieste contatto"], ["testi", "Testi del sito"]];

export default function SitoWebPage() {
  const [sp, setSp] = useSearchParams();
  const tab = sp.get("tab") || "case";
  return (
    <div data-testid="sito-web-page">
      <PageHeader eyebrow="Comunicazione" title="Sito web" subtitle="Gestisci case history, testi e richieste arrivate da corefvg.com."
        actions={<a href="/" target="_blank" rel="noreferrer" className="inline-flex h-11 items-center gap-1.5 rounded-full bg-[#0A1128] px-5 text-sm font-bold text-white hover:bg-[#E8173A] transition-colors" data-testid="sito-web-open-site"><ExternalLink className="h-4 w-4" />Apri il sito</a>} />
      <Tabs value={tab} onValueChange={(v) => setSp({ tab: v }, { replace: true })}>
        <TabsList className="bg-[#A6DAFC] border border-slate-200 rounded-full p-1 h-auto mb-6 max-w-full">
          {TABS.map(([k, l]) => <TabsTrigger key={k} value={k} className="rounded-full px-5 py-2 font-bold text-sm data-[state=active]:bg-[#0A1128] data-[state=active]:text-white" data-testid={`sito-tab-${k}`}>{l}</TabsTrigger>)}
        </TabsList>
        <TabsContent value="case"><CaseList /></TabsContent>
        <TabsContent value="richieste"><RequestsInbox /></TabsContent>
        <TabsContent value="testi"><SiteTexts /></TabsContent>
      </Tabs>
    </div>
  );
}
